<template>
    <div class="Sink">
        <HeaderTitle>sink-title</HeaderTitle>

        <hr>
        <h3>Buttons</h3>
        <v-btn color="success">btn success</v-btn>
        <v-btn color="danger">btn danger</v-btn>
        <v-btn color="primary">btn primary</v-btn>
        <v-btn color="secondary">btn secondary</v-btn>
        <v-btn color="dark">btn dark</v-btn>
        <v-btn color="red">btn red</v-btn>
        <v-btn color="warning">btn warning</v-btn>
        <v-btn color="accent">btn accent</v-btn>
        <hr>
        <v-btn text color="success">btn text success</v-btn>
        <v-btn text color="danger">btn text danger</v-btn>
        <v-btn text color="primary">btn text primary</v-btn>
        <v-btn text color="secondary">btn text secondary</v-btn>
        <v-btn text color="dark">btn text dark</v-btn>
        <v-btn text color="red">btn text red</v-btn>
        <v-btn text color="warning">btn text warning</v-btn>
        <v-btn text color="accent">btn text accent</v-btn>
        <hr>
        <v-btn disabled color="success">btn disabled success</v-btn>
        <v-btn disabled color="danger">btn disabled danger</v-btn>
        <v-btn disabled color="primary">btn disabled primary</v-btn>
        <v-btn disabled color="secondary">btn disabled secondary</v-btn>
        <v-btn disabled color="dark">btn disabled dark</v-btn>
        <v-btn disabled color="red">btn disabled red</v-btn>
        <v-btn disabled color="warning">btn disabled warning</v-btn>
        <v-btn disabled color="accent">btn disabled accent</v-btn>
        <hr>
        <v-btn disabled text color="success">btn disabled text success</v-btn>
        <v-btn disabled text color="danger">btn disabled text danger</v-btn>
        <v-btn disabled text color="primary">btn disabled text primary</v-btn>
        <v-btn disabled text color="secondary">btn disabled text secondary</v-btn>
        <v-btn disabled text color="dark">btn disabled text dark</v-btn>
        <v-btn disabled text color="red">btn disabled text red</v-btn>
        <v-btn disabled text color="warning">btn disabled text warning</v-btn>
        <v-btn disabled text color="accent">btn disabled text accent</v-btn>
        <hr>
    </div>
</template>

<script>
    export default {
        props: {},
    };
</script>
